module.exports = __webpack_public_path__ + "img/123.c42c655f.png";